export const ADD_TAGS_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.asset.tag.AddTags.AssetModificationNotPermitted';
export const ADD_TAGS_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.asset.tag.AddTags.EntityNotFoundOrNotAccessible';
export const ADD_TAGS_SUCCESS_TAGS_ADDED = 'europa.asset.tag.AddTags.TagsAdded';
export const ADD_TAGS_FAILURE_UNEXPECTED_FAILURE = 'europa.asset.tag.AddTags.UnexpectedFailure';
export const REMOVE_TAGS_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.asset.tag.RemoveTags.AssetModificationNotPermitted';
export const REMOVE_TAGS_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.asset.tag.RemoveTags.EntityNotFoundOrNotAccessible';
export const REMOVE_TAGS_SUCCESS_TAGS_REMOVED = 'europa.asset.tag.RemoveTags.TagsRemoved';
export const REMOVE_TAGS_FAILURE_UNEXPECTED_FAILURE =
    'europa.asset.tag.RemoveTags.UnexpectedFailure';
